import { render } from "./main.vue?vue&type=template&id=7b548600"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"

import "./main.vue?vue&type=style&index=0&id=7b548600&lang=less"
const cssModules = {}
import style1 from "./less/attachments.less?vue&type=style&index=1&module=true&lang=css&external"
cssModules["$style"] = style1

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__